import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const LISTINGPAYMENTPLANS_LIST = "listingpaymentplans_list";
export const CREATE_LISTINGPAYMENTPLANS = "create_listingpaymentplans";
export const UPDATE_LISTINGPAYMENTPLANS = "update_listingpaymentplans";
export const DELETE_LISTINGPAYMENTPLANS = "delete_listingpaymentplans";
export const GET_LISTINGPAYMENTPLANS_DETAILS = "get_listingpaymentplans_details";
export const LISTINGPAYMENTPLANS_SIMPLE_LIST = "listingpaymentplans_simple_details";
export const UPDATE_LISTINGPAYMENTPLANS_STATUS = "UPDATE_LISTINGPAYMENTPLANS_STATUS";
export const CLEAR_LISTINGPAYMENTPLANS_ERRORS = "clearListingPaymentPlansErrors";

// mutation types
export const SET_LISTINGPAYMENTPLANS_ERROR = "setListingPaymentPlansErrors";
export const REMOVE_LISTINGPAYMENTPLANS_ERRORS = "removeListingPaymentPlansErrors";

const state = {
    errors: null,
    listingPaymentPlanDistribution: [],
    listingPaymentPlanDistributionPP: [],
};
const actions = {
    [LISTINGPAYMENTPLANS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/listingpaymentplans?listing_id=" + payload.listing_id  + '&' + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_LISTINGPAYMENTPLANS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_LISTINGPAYMENTPLANS_ERROR, response.errors);
                });
        });
    },
    [CREATE_LISTINGPAYMENTPLANS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createlistingpaymentplan", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_LISTINGPAYMENTPLANS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_LISTINGPAYMENTPLANS_ERROR, response.errors);
                });
        });
    },
    [UPDATE_LISTINGPAYMENTPLANS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatelistingpaymentplan", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_LISTINGPAYMENTPLANS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_LISTINGPAYMENTPLANS_ERROR, response.errors);
                });
        });
    },
    [DELETE_LISTINGPAYMENTPLANS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletelistingpaymentplan", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_LISTINGPAYMENTPLANS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_LISTINGPAYMENTPLANS_ERROR, response.errors);
                });
        });
    },
    [GET_LISTINGPAYMENTPLANS_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getlistingpaymentplandetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_LISTINGPAYMENTPLANS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_LISTINGPAYMENTPLANS_ERROR, response.errors);
                });
        });
    },
    [CLEAR_LISTINGPAYMENTPLANS_ERRORS](context) {
        context.commit(REMOVE_LISTINGPAYMENTPLANS_ERRORS);
    },
    [LISTINGPAYMENTPLANS_SIMPLE_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/listingpaymentplanssimple?listing_id=" + payload.listing_id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                }).catch(({response}) => {
                context.commit(SET_LISTINGPAYMENTPLANS_ERROR, response.errors);
            });
        });
    },
    [UPDATE_LISTINGPAYMENTPLANS_STATUS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatelistingpaymentplanstatus", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_LISTINGPAYMENTPLANS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_LISTINGPAYMENTPLANS_ERROR, response.errors);
                });
        });
    },
};

const mutations = {
    [SET_LISTINGPAYMENTPLANS_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_LISTINGPAYMENTPLANS_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
